import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./slice/userSlice";
import movieReducer from "./slice/movieSlice";
import errorReducer from "./slice/errorSlice";
import pendingReducer from "./slice/pendingSlice";

const appStore = configureStore({
  reducer: {
    user: userReducer,
    movies: movieReducer,
    error: errorReducer,
    pending: pendingReducer,
  },
});

export default appStore;
